import React, {useState, useEffect} from 'react'

const FlashCards = (props) => {
    const topic = props.topic
    const allStudies = props.allStudies//array of objects
    const setNames = props.setNames//string
    const [studies, setStudies] = useState([{}])
    const [ID, setID] = useState("")
    const [showCards, setShowCards] = useState(true)

    useEffect(() => {
        const filterStudies = () => {
            let titles = []
            let content = []
            let ids = []
           // console.log(allStudies)
            for(let i = 0; i < allStudies.length; i++) {//get ids
                if(allStudies[i].studyTitle === setNames) {
                    ids.push(allStudies[i]._id.$oid)
                }
            }
           // console.log(ids)
           
            allStudies.filter(s => s.topicName === topic && s.studyTitle === setNames).map((subject) => {//get specific content
                titles = subject.cardTitles
                content = subject.cardContent
                //console.log(subject._id.$oi
                return null
            })
           // console.log(ids)
            let newArr = []
            for(let i = 0; i < titles.length; i++) {
                let card = {}
                if(titles[i] !== undefined){
                    card['title'] = titles[i]
                    card['content'] = content[i]
                    let rand =  Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                    card['id'] = rand
                    newArr.push(card)
                }
            }
          //  console.log(newArr)
            setStudies(newArr)
        }
        filterStudies()
    }, [allStudies, setNames, topic])

    const ans = (id) => {
        if(id === ID){
            setID('')
        }else{
        setID(id)
        }
    }
    const wordStyle = {

    }


    return (
        <div>
            <div className="level-item">
                 <button onClick={() => setShowCards(!showCards)} className="button is-primary is-large">{topic}</button>
            </div>
            {showCards && <div style={{paddingTop: "10%"}}>
                {studies.filter(s => s !== undefined).map((item,i) => {
                   return( 
                    <div style={{paddingBottom: "15%"}} key={i}>
                        <ul key={i}>
                        <li  key={i}>
                    <div key={i}  className="card">
                        <header key={i+1} className="card-header has-background-warning">
                                <p style={wordStyle} className="card-header-title">{item.title}</p>
                            <div onClick={() => ans(item.id)} className="card-header-icon" aria-label="more options">
                            <span className="icon">
                                <button className="fas fa-angle-down"></button>
                            </span>
                            </div>
                        </header>
                        {ID === item.id && (<div key={i} className="columns">
                            <div key={i}>
                                <div key={i} className="card-content">
                                    <div key={i} style={wordStyle} className="content">
                                        {item.content}
                                        <br/>
                                    </div>
                                </div>
                            </div>
                        </div>)}
                        </div>
                        </li>
                        </ul>
                        </div>

                   )
                }) }
            </div>}
            </div>
    )
}
/*
(<div key={i} className="columns">
                            <div key={i} className="column">
                                <div key={i} className="card-content">
                                    <div key={i} className="content">
                                        {item.content}
                                    </div>
                                </div>
                            </div>
                        </div>) : null
*/

export default FlashCards